var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 1037,
    viewBox: "0 0 1728 1037",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3301_17689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1728,
    height: 1037
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    width: 1728,
    height: 1037,
    fill: "#242734"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3301_17689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.16,
    cx: 1536,
    cy: 611.5,
    rx: 688,
    ry: 677.5,
    fill: "url(#paint0_radial_3301_17689)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.35,
    cx: 313.874,
    cy: 311,
    rx: 828.874,
    ry: 778,
    fill: "url(#paint1_radial_3301_17689)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_b_3301_17689)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1037,
    fill: "#242734"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3301_17689",
    x: -4,
    y: -4,
    width: 1736,
    height: 1045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3301_17689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3301_17689",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3301_17689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1536 811.394) rotate(101.551) scale(487.478 496.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C2B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3301_17689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(314 311) rotate(62.3474) scale(659.402 675.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLayer);
export default __webpack_public_path__ + "static/media/background-layer.a97de24c6c46e984c5d4169c4ff3286e.svg";
export { ForwardRef as ReactComponent };